import { useState } from "react";
import Container from "olive-react-myoneui/lib/Container";

function CourseBundleDescription({className, courseBundleDescTitle, courseBundleDesc,requirements="",whatUGet=""}) {
  
  const requirementlist = requirements && requirements.map((number) =>
    <li>{number}</li>
  );
  const whatUGetlist = whatUGet && whatUGet.map((number) =>
    <li>{number}</li>
  );

  return (
    <div className={`${className || ""} bundle-courses-description p-0`}>
      <h4 className="fw-bold course-overview-title">{courseBundleDescTitle}</h4>
      <p className="course-overview-desc"
      dangerouslySetInnerHTML={{__html: courseBundleDesc}}
      />
      {requirements && <>
        <h4 className="fw-bold course-overview-title">Requirements</h4>
        <p className="course-overview-desc">{requirementlist}</p>
        </>
      }
      {whatUGet && <>
        <h4 className="fw-bold course-overview-title">What You Will Get</h4>
        <p className="course-overview-desc">{whatUGetlist}</p>
        </>
      }
      
     
    </div>
  );
}

export default CourseBundleDescription;
